import Swiper from 'swiper';

export function tabs() {

    let tab = document.querySelectorAll('[data-tab]'),
        tabsContent = document.querySelectorAll('[data-tabs-content]');
    tab.forEach( function(item) {
        item.addEventListener('click', function() {
            let num = item.dataset.tab;

            tab.forEach( function(elem) {
                elem.classList.remove('is-active');
            });

            tabsContent.forEach( function(content) {
                content.classList.remove('is-active');
            });


            item.classList.add('is-active');
            document.querySelector(`[data-tabs-content="${num}"]`).classList.add('is-active');
        });
    });


    if (window.innerWidth  < 671) {

        let tabsSlider = new Swiper('.tabs-slider', {
            containerModifierClass: 'tabs-slider',
            wrapperClass: 'tabs-slider__wrapper',
            slideClass: 'tabs-slide',
            slideActiveClass: 'is-active',
            slidesPerView: 'auto',
            simulateTouch: true,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
        });

        tabsSlider.on('transitionStart', function() {

            tabsSlider.slides[tabsSlider.activeIndex];
            let allSlides = document.querySelectorAll('.tabs-slide');

            if (tabsSlider.isEnd) {
                allSlides.forEach( function(item) {
                    item.classList.remove('is-active');
                })

                tabsSlider.slides[allSlides.length - 1].classList.add('is-active');
            }

            let num = document.querySelector('.tabs-slide.is-active').dataset.tab;

            tabsContent.forEach( function(content) {
                content.classList.remove('is-active');
            });

            document.querySelector(`[data-tabs-content="${num}"]`).classList.add('is-active');
        })
    }
}
